module.exports = __webpack_public_path__ + "static/media/pg_tidepool_tablet_kelly_benoit_bird.4309d921.png";